export default __webpack_public_path__ + "static/media/Greenline_darkBG-trans-wht-text.28fce09d.svg";